export enum Duration {
  FifteenMinutes = 15,
  ThirtyMinutes = 30,
  FortyFiveMinutes = 45,
  OneHour = 60,
  AllDay = 1440,
  EndDate
}
